import { render, staticRenderFns } from "./recruitInfoPages.vue?vue&type=template&id=938c5e4e&scoped=true"
import script from "./recruitInfoPages.vue?vue&type=script&lang=js"
export * from "./recruitInfoPages.vue?vue&type=script&lang=js"
import style0 from "./recruitInfoPages.vue?vue&type=style&index=0&id=938c5e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938c5e4e",
  null
  
)

export default component.exports